import script from "./KikakuKihon.vue?vue&type=script&setup=true&lang=ts"
export * from "./KikakuKihon.vue?vue&type=script&setup=true&lang=ts"

import "./KikakuKihon.vue?vue&type=style&index=0&id=6e2a257e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e2a257e"]])

export default __exports__